import React from 'react';
import {
  ProductMasterDataExportConfigurationContext,
  ProductMasterDataExportConfigurationContextProps,
} from '../context/ProductMasterDataExportConfigurationContext';
import { useAppDispatch, useAppSelector } from '../ui/pages/store';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { v4 } from 'uuid';
import { ProductMasterDataExportConfiguration } from '../types/product_master_data_export_configuration';

const productMasterDataExportConfigurationState = {
  items: new Map<string, ProductMasterDataExportConfiguration>(),
  loading: false,
};

export const productMasterDataExportConfigurationSlice = createSlice({
  name: 'productMasterDataExportConfiguration',
  initialState: { key: v4() },
  reducers: {
    reset: state => {
      productMasterDataExportConfigurationState.items = new Map();
      productMasterDataExportConfigurationState.loading = true;
      state.key = v4();
    },
    set: (state, action: PayloadAction<ProductMasterDataExportConfiguration[]>) => {
      productMasterDataExportConfigurationState.items = new Map();
      action.payload.forEach(p =>
        productMasterDataExportConfigurationState.items.set(p.id, new ProductMasterDataExportConfiguration(p)),
      );
      state.key = v4();
    },
    add: (state, action: PayloadAction<ProductMasterDataExportConfiguration[]>) => {
      action.payload.forEach(p =>
        productMasterDataExportConfigurationState.items.set(p.id, new ProductMasterDataExportConfiguration(p)),
      );
      productMasterDataExportConfigurationState.items = new Map(productMasterDataExportConfigurationState.items);
      state.key = v4();
    },
    delete: (state, action: PayloadAction<ProductMasterDataExportConfiguration[]>) => {
      action.payload.forEach(p => productMasterDataExportConfigurationState.items.delete(p.id));
      productMasterDataExportConfigurationState.items = new Map(productMasterDataExportConfigurationState.items);
      state.key = v4();
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      productMasterDataExportConfigurationState.loading = action.payload;
      state.key = v4();
    },
  },
});

interface ProductMasterDataExportConfigurationProviderProps {
  children: React.ReactNode;
}

export default function ProductMasterDataExportConfigurationProvider({
  children,
}: ProductMasterDataExportConfigurationProviderProps) {
  const dispatch = useAppDispatch();
  const key = useAppSelector(state => state.productMasterDataExportConfigurations.key);

  const productMasterDataExportConfigurationContext: ProductMasterDataExportConfigurationContextProps = {
    productMasterDataExportConfigurations: productMasterDataExportConfigurationState.items,
    productMasterDataExportConfigurationsLoading: productMasterDataExportConfigurationState.loading,
    setProductMasterDataExportConfigurations: (
      productMasterDataExportConfigurations: Map<string, ProductMasterDataExportConfiguration>,
    ) => {
      dispatch(
        productMasterDataExportConfigurationSlice.actions.set([...productMasterDataExportConfigurations.values()]),
      );
    },
  };

  return (
    <ProductMasterDataExportConfigurationContext.Provider value={productMasterDataExportConfigurationContext}>
      {children}
    </ProductMasterDataExportConfigurationContext.Provider>
  );
}
